import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-multi-value-field',
  templateUrl: './multi-value-field.component.html',
  styleUrls: ['./multi-value-field.component.scss'],
})
export class MultiValueFieldComponent {
  @Input({ required: true }) control!: FormControl;
  @Input({ required: true }) label!: string;

  readonly chipInputSeparatorCodes = [ENTER, COMMA];

  addItem(event: MatChipInputEvent): void {
    const value = event.value.trim();

    const newValues = value
      .split(/[,;]/)
      .map(v => v.trim())
      .filter(v => !!v);

    if (newValues.length > 0) {
      const finalValues = new Set();
      this.control.value.forEach((v: string) => finalValues.add(v));
      newValues.forEach(v => finalValues.add(v));
      this.control.patchValue(Array.from(finalValues));
    }

    event.chipInput?.clear();
  }

  removeItem(item: string): void {
    const index = this.control.value.indexOf(item);

    if (index >= 0) {
      const values = [...this.control.value];
      values.splice(index, 1);
      this.control.patchValue(values);
    }
  }

  editItem(item: string, event: MatChipEditedEvent): void {
    const value = event.value.trim();

    if (!value) {
      this.removeItem(item);
      return;
    }

    const index = this.control.value.indexOf(item);
    if (index >= 0) {
      const values = [...this.control.value];
      values[index] = { item, value };
      this.control.patchValue(values);
    }
  }
}
